"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTokenLoginBody = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateTokenLoginBody = (0, validation_1.properties)({
    email: (0, validation_1.optional)((0, validation_1.text)()),
    code: (0, validation_1.optional)((0, validation_1.text)()),
});
//# sourceMappingURL=TokenLoginBody.js.map